import script from "./HtmlEditorWorkbench.vue?vue&type=script&setup=true&lang=js"
export * from "./HtmlEditorWorkbench.vue?vue&type=script&setup=true&lang=js"

import "./HtmlEditorWorkbench.vue?vue&type=style&index=0&id=2ed44d7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed44d7e"]])

export default __exports__